export default __webpack_public_path__ + "static/media/11.f4f025d0.png";